export const ADTYPE = {
  CTN: 'ctn',
  TABOOLA: 'taboola',
  DFP: 'dfp',
};

const getAdDivId = (jarvisad, adData) => {
  const { data } = adData;
  let divId = data.divId || jarvisad.divId;
  if (jarvisad.replace) {
    divId = jarvisad.divId;
  }
  if (adData.msid) {
    divId += `-${adData.msid}`;
  }
  return divId;
};
const markAndAllot = multiAds => {
  const isClient = typeof window !== 'undefined';
  const key = isClient ? 'marked' : 'smarked';
  const { length } = multiAds.filter(r => r[key] === 1);
  const idx = length === multiAds.length ? length - 1 : length;
  const obj = multiAds[idx];
  obj[key] = 1;
  return obj;
};
const updatefromMultipleAds = (jarvisad, isCTN, name) => {
  const { multiAds, size, divId } = jarvisad;

  jarvisad.adCounter = jarvisad.adCounter ? jarvisad.adCounter + 1 : 1;
  let newObj = markAndAllot(multiAds);
  if (newObj) {
    const id = jarvisad.adCounter - 1 || '';
    newObj = {
      name: name + id,
      size,
      ...newObj,
    };
    if (divId) {
      newObj.divId = divId + (newObj.adCounter || id);
      if (isCTN) {
        // TODO:// will remove this | TOIPR-79362
        newObj.msid = newObj.divId;
      }
    }
    return newObj;
  }
  return jarvisad;
};

const failoverupdate = (jfailover, failover) =>
  failover.map((ele, i) => {
    const newUpdate = jfailover[i] || {};
    return { ...ele, ...newUpdate };
  });

const updatedAdData = (jarvisad, adData, name) => {
  const { isCTN, data } = adData;
  const { failover } = data;
  if (jarvisad.failover?.length && failover?.length) {
    jarvisad.failover = failoverupdate(jarvisad.failover, failover);
  }

  if (jarvisad.multiAds) {
    return updatefromMultipleAds(jarvisad, isCTN, name);
  }

  if (isCTN) {
    return {
      ...data,
      ...jarvisad,
      jarvisad: true,
    };
  }

  return {
    ...data,
    ...jarvisad,
    divId: getAdDivId(jarvisad, adData),
    jarvisad: true,
  };
};

const findSpecialAds = (adsarr, name) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const ele of adsarr) {
    if (ele.name === name) {
      return ele;
    }
  }
  return null;
};

const findCodeWithName = (revenueAds, name, skipReplace) => {
  try {
    const { layout = {}, content, specialAds } = revenueAds;
    const ctns = content?.ctn || {};
    const dfps = content?.dfp || {};
    const mgidAds = content?.mgid || {};
    const taboolaAds = content?.taboola || {};

    const mrecs = content?.dfp?.mrecs || {};
    const midAds = content?.dfp?.midAds || {};
    const dymObj = {};
    let jarvisad;
    if (skipReplace) {
      dymObj.adType = ADTYPE.DFP;
    }
    if (layout[name]) {
      jarvisad = layout[name];
    } else if (dfps[name]) {
      jarvisad = dfps[name];
    } else if (mrecs[name]) {
      jarvisad = mrecs[name];
    } else if (midAds[name]) {
      jarvisad = midAds[name];
    } else if (ctns[name]) {
      jarvisad = ctns[name];
      dymObj.adType = ADTYPE.CTN;
    } else if (taboolaAds[name]) {
      jarvisad = taboolaAds[name];
      dymObj.adType = ADTYPE.TABOOLA;
    } else if (mgidAds[name]) {
      jarvisad = mgidAds[name];
      dymObj.mgid = true;
    } else if (specialAds) {
      jarvisad = findSpecialAds(specialAds, name);
    }

    if (jarvisad?.replacewith && !skipReplace) {
      jarvisad = findCodeWithName(revenueAds, jarvisad.replacewith, true);
    }

    if (jarvisad) {
      if (jarvisad.multiAds) {
        return jarvisad;
      }
      return {
        ...dymObj,
        ...jarvisad,
      };
    } else if(!skipReplace) {
      const parentName = name.slice(0, -1);
      jarvisad = findCodeWithName(revenueAds, parentName, true);
    }
    return jarvisad;
  } catch (error) {
    console.log(error);
    return null;
  }
};

// eslint-disable-next-line import/prefer-default-export
export const findJarvisAdCode = adData => {
  try {
    if (!adData || typeof adData !== 'object') {
      return null;
    }
    const { data = {}, revenueAds } = adData;
    const { name, jname } = data;
    const adName = jname || name;
    const jConfExist = revenueAds && Object.keys(revenueAds).length;
    if (jConfExist && adName) {
      const jarvisad = findCodeWithName(revenueAds, adName);
      if (jname && !jarvisad) {
        return { jdisabled: true };
      }
      return jarvisad ? updatedAdData(jarvisad, adData, adName) : null;
    }
    return null;
  } catch (error) {
    return null;
  }
};
